module.exports = __webpack_public_path__ + "static/media/Newt Scamander 2.5ae0e3c7.jpg";